import { back, push } from '@lagunovsky/redux-react-router'
import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'

import useLocalStorage from '../../app/hooks/useLocalStorage'
import Basket from '../../components/Basket/Basket'
import { ALLOWED_PAYMENTS, BASKET_TYPES } from '../../components/Basket/constants'
import CinemaTypeImg from '../../components/CinemaTypeImg/CinemaTypeImg'
import Goods from '../../components/Goods/Goods'
import OrderStepsHeader from '../../components/OrderStepsHeader/OrderStepsHeader'
import { PAGE_NAME } from '../../components/OrderStepsHeader/constants'
import InfoWindow from '../../components/Windows/InfoWindow/InfoWindow'
import useErrorMessage from '../../components/Windows/InfoWindow/hooks/useErrorMessage'
import { getCinemaType } from '../../global/helpers'
import HallMovie from '../Hall/components/HallMovie/HallMovie'
import { getCinemaSlug } from '../Hall/helpers'
import ClubCard from './components/ClubCard/ClubCard'
import GiftVoucher from './components/GiftVoucher/GiftVoucher'
import PaymentMethod from './components/PaymentMethod/PaymentMethod'
import Tickets from './components/Tickets/Tickets'

import hocOrderSummary from './hocOrderSummary'

import FormCustomBenefitPayment from 'components/Forms/FormCustomBenefitPayment/FormCustomBenefitPayment'
import { useEffect } from 'react'
import useSendBasketGtmInfo from 'services/gtm/useSendBasketGtmInfo'
import './OrderSummary.scss'
import { getRemainingPoints } from './helpers'

const OrderSummary = ({
    isAuth,
    emptyBasket,
    loading,
    error,
    setPayment,
    paymentStart,
    reservationStart,
    basket,
    selectedPayment,
    isClubMember,
    accountPoints,
    cardValidity,
    isExpiring,
    userAuthInfo,
    eventid,
    cinemaid,
    setCardProlonge,
    goPayVariant,
    setGoPayVariant,
}) => {
    const intl = useIntl()
    const dispatch = useDispatch()
    const errorMessage = useErrorMessage(error?.message)
    const [userInfo] = useLocalStorage('user-info', null)

    const site = getCinemaSlug(cinemaid)

    const isClubCardInBasket = Array.isArray(basket?.items_cards) && basket?.items_cards[0]

    const isReservation = selectedPayment === ALLOWED_PAYMENTS.CASH

    useEffect(() => {
        const userInfo = localStorage.getItem('user-info')
        if (basket?.cartid === -1 || (isAuth === false && !userInfo)) {
            dispatch(back())
        }
    }, [])

    useSendBasketGtmInfo(basket, site, 'add_payment_info')

    const remainingPoints = getRemainingPoints(basket, accountPoints)

    return (
        <Container fluid className={'order-summary-page d-flex flex-column'}>
            {basket?.items_tickets?.map((item, index) => {
                const event = item?.event
                const cinemaType = getCinemaType(event?.event_properties)

                if (index === 0)
                    return (
                        <CinemaTypeImg
                            key={event?.eventid}
                            cinemaType={cinemaType}
                            page={PAGE_NAME.orderSummary}
                            imgUrl={event?.imageUrl}
                            imgAlt={event?.title_group}
                        />
                    )
            })}

            <OrderStepsHeader
                cardInBasket={isClubCardInBasket}
                isAuth={isAuth}
                eventid={eventid}
                site={site}
                loading={loading}
                active={PAGE_NAME.orderSummary}
                emptyBasket={emptyBasket}
                cardValidity={cardValidity}
                isClubMember={isClubMember}
                isExpiring={isExpiring}
                selectedPayment={selectedPayment}
                text={intl.formatMessage(
                    { id: isReservation ? 'orderSteps.fourthRes' : 'orderSteps.fourth' },
                    { span: (chunks) => <span className="non-mobile">{chunks}</span> }
                )}
                onClickBack={() =>
                    !isAuth ? dispatch(push(`/${PAGE_NAME.contactInfo}`)) : dispatch(push(`/${PAGE_NAME.yourOrder}`))
                }
                onClickExtend={() => setCardProlonge()}
            />
            <div className={'order-summary-page--content position-relative d-flex flex-column mx-auto'}>
                {error && <InfoWindow color={'red'} description={errorMessage} withScroll withTimer />}
                {isReservation && <InfoWindow color={'white'} description={basket?.note} />}

                <Container fluid className="order-summary-page--tickets d-flex">
                    <div className="d-flex flex-column w-100">
                        {
                            /* JUST for SKELETON use*/ !basket?.items_tickets?.length &&
                                !basket?.items_vouchers?.length &&
                                !basket?.items_cards?.length && <HallMovie loading={true} />
                        }
                        {basket?.items_tickets?.map((item, index) => {
                            const event = item?.event
                            const tickets = item?.tickets
                            const cinemaType = getCinemaType(event?.event_properties)

                            return (
                                <div key={event?.eventid} className="d-flex flex-column w-100 gap-5">
                                    <HallMovie loading={loading} movie={event} cinemaType={cinemaType} />
                                    <div key={event?.eventid} className="order-summary-page--first-tickets ">
                                        <Tickets
                                            isReservation={isReservation}
                                            remainingPoints={remainingPoints}
                                            disabled={loading}
                                            tickets={tickets}
                                            isClubMember={isClubMember}
                                        />

                                        {!isReservation && index === 0 && (
                                            <ClubCard
                                                points={remainingPoints}
                                                isClubMember={isClubMember}
                                                isExpiring={isExpiring}
                                                isAuth={isAuth}
                                            />
                                        )}
                                        {/*isReservation && index === 0 && <DownloadApp /> odkomentovat až bude mobilní appka*/}
                                    </div>
                                </div>
                            )
                        })}

                        <div className="d-flex flex-column w-100 gap-3">
                            {/* display card if added - there should be just one type of card*/}
                            {isClubCardInBasket && (
                                <Goods
                                    leftTitle={intl.formatMessage({ id: 'orderSummary.goods.membership.title' })}
                                    description={intl.formatMessage({
                                        id: 'orderSummary.goods.membership.description',
                                    })}
                                    price={basket?.items_cards[0].price}
                                    currency={basket?.currency}
                                />
                            )}

                            {/* display all meal if added */}

                            {basket?.items_vouchers?.map((meal, idx) => {
                                const description = `${meal.name} ${meal.amount} ks`
                                return (
                                    <Goods
                                        key={idx}
                                        leftTitle={intl.formatMessage({ id: 'orderSummary.goods.meal.title' })}
                                        description={description}
                                        price={meal.price}
                                        currency={basket.currency}
                                    />
                                )
                            })}
                        </div>
                    </div>
                </Container>

                {!isReservation && (
                    <>
                        <GiftVoucher />
                        <PaymentMethod
                            selectedPayment={basket?.selected_payment}
                            setPaymentMethod={(payment) => setPayment(payment)}
                            note={basket?.note}
                            allowedPayments={basket?.allowed_payments}
                            loading={loading}
                            goPayVariant={goPayVariant}
                            setGoPayVariant={setGoPayVariant}
                        />
                    </>
                )}
            </div>
            <FormCustomBenefitPayment />
            {isReservation ? (
                <Basket
                    show
                    variant={BASKET_TYPES.RESERVATION}
                    onPayment={() => reservationStart(isAuth ? userAuthInfo : userInfo)}
                    loading={loading}
                />
            ) : (
                <>
                    <Basket
                        show
                        variant={BASKET_TYPES.PAYMENT}
                        onPayment={() => paymentStart({ user: isAuth ? userAuthInfo : userInfo, basket })}
                        loading={loading}
                    />
                    <img
                        src={'images/cinestar/astronaut-thumbs-up.png'}
                        alt={'astronaut-thumbs-up'}
                        className={'astronaut-animate w-50 h-auto mx-auto'}
                    />
                </>
            )}
        </Container>
    )
}

export default hocOrderSummary(OrderSummary)
